import baseStyled, { css as baseCss, ThemedCssFunction, ThemedStyledInterface } from 'styled-components';

import Button from '@plasma/ui.general.button';
import Select from '@plasma/ui.input.select';

import { PlannedDemandPageTheme } from './themes/types';

const styled = baseStyled as ThemedStyledInterface<PlannedDemandPageTheme>;
const css = baseCss as ThemedCssFunction<PlannedDemandPageTheme>;

export const PlannedDemandPage = styled.div`
  width: 100%;
  height: 100%;
`;

export const NormalPlasmaButton = styled(Button)`
  ${({ theme }) => css`
    background-color: ${theme.mode.plannedDemandPage.normalButtonBGColor} !important;
    border: ${theme.mode.plannedDemandPage.normalButtonBorderColor} !important;
  `}
`;

export const NormalPlasmaSelect = styled(Select)`
  .ant-select-clear {
    margin-right: 1vw;
  }
`;

export const ActionContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 15px;
  padding: 8px 12px;
  margin: 10px 20px;
  width: calc(100% - 40px);
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1);
  background-color: #ffffff;
`;
